import React from 'react';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import PageTitle from '@component/PageTitle';
import WBRString from '@component/WbrString';

const PageTitleComponent = (props) => {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  return (
    <div className="pagetitle-container">
      <PageTitle
        title={<Text field={props.sitecoreContext.route.fields.pagetitle} />}
        cta={
          props.sitecoreContext.route.fields.pagetitlelink?.value.href &&
          props.sitecoreContext.route.fields.pagetitlelink?.value.text && (
            <>
              <RoutableLink field={props.sitecoreContext.route.fields.pagetitlelink} useATag={true}>
                <WBRString tag="span">{props.sitecoreContext.route.fields.pagetitlelink?.value.text}</WBRString>
              </RoutableLink>
              <EditableLink linkField={props.sitecoreContext.route.fields.pagetitlelink} isEditing={isEditing} />
            </>
          )
        }
      />
    </div>
  );
};

export default withSitecoreContext()(PageTitleComponent);
